import { BarChart3, LineChart, PieChart, Table2, Activity } from 'lucide-react';

export type ChartType = 'line' | 'area' | 'bar' | 'pie' | 'donut' | 'table' | 'kpi';

interface ChartSelectorProps {
  selected: ChartType;
  onChange: (type: ChartType) => void;
  availableTypes?: ChartType[];
  size?: 'sm' | 'md';
}

const CHART_OPTIONS: { type: ChartType; icon: React.ElementType; label: string }[] = [
  { type: 'line', icon: LineChart, label: 'Line' },
  { type: 'bar', icon: BarChart3, label: 'Bar' },
  { type: 'pie', icon: PieChart, label: 'Pie' },
  { type: 'table', icon: Table2, label: 'Table' },
  { type: 'kpi', icon: Activity, label: 'KPI' },
];

export default function ChartSelector({
  selected,
  onChange,
  availableTypes,
  size = 'sm',
}: ChartSelectorProps) {
  const filteredOptions = availableTypes
    ? CHART_OPTIONS.filter((opt) => availableTypes.includes(opt.type))
    : CHART_OPTIONS;

  const buttonSize = size === 'sm' ? 'p-1.5' : 'p-2';
  const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';

  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-lg bg-secondary/50">
      {filteredOptions.map(({ type, icon: Icon, label }) => (
        <button
          key={type}
          onClick={() => onChange(type)}
          className={`${buttonSize} rounded transition-colors ${
            selected === type
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground hover:bg-secondary'
          }`}
          title={label}
        >
          <Icon className={iconSize} />
        </button>
      ))}
    </div>
  );
}
